<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import appConfig from "@/app.config";
import festivalSvc from "@/services/festival";
import { toast } from "vue3-toastify";

/**
 * Customers component
 */
export default {
  page: {
    title: "Festival",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Festival",
      items: [
        {
          text: "Setting",
          href: "#",
        },
        {
          text: "Festival",
          active: true,
        },
      ],
      columns: [
        {
          field: "uuid",
          hidden: true,
        },
        {
          label: "Name (TH)",
          field: "name",
        },
        {
          label: "Name (EN)",
          field: "nameEn",
        },
        {
          label: "Created Date",
          field: "createdAt",
        },
        {
          label: "Updated Date",
          field: "updatedAt",
        },
        {
          label: "Action",
          field: "button",
          html: true,
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      rows: [],
      showModalCreate: false,
      showModalEdit: false,
      submitted: false,
      festival: {
        uuid: "",
        name: "",
        nameEn: "",
      },
      festivalList: [],
      festivalListEn: [],
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    festival: {
      name: {
        required: helpers.withMessage("festival (TH) is required", required),
      },
      nameEn: {
        required: helpers.withMessage("festival (EN) is required", required),
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      festivalSvc.getAll().then((resp) => {
        if (resp.data.data === null) {
          return;
        }
        this.rows = resp.data.data;
        resp.data.data.forEach((festival) => {
          this.festivalList.push(festival.name);
          this.festivalListEn.push(festival.nameEn);
        });
      });
    },
    create() {
      this.festival.uuid = "";
      this.festival.name = "";
      this.festival.nameEn = "";
      this.submitted = false;
      this.showModalCreate = true;
    },
    handleSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        if (
          this.festivalList.includes(this.festival.name) ||
          (this.festival.nameEn !== "" && this.festivalListEn.includes(this.festival.nameEn))
        ) {
          toast.error("this festival has already been used", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          return;
        }

        festivalSvc
          .create(this.festival)
          .then((resp) => {
            if (resp.status === 200) {
              toast.success("Created Successfully", {
                autoClose: localStorage.getItem("toastCountdown"),
              });
            } else {
              toast.error("Created Failed", {
                autoClose: localStorage.getItem("toastCountdown"),
              });
            }
          })
          .catch((err) => {
            toast.error(err, {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          })
          .finally(() => {
            this.get();
            this.showModalCreate = false;
            this.submitted = false;
          });
      }
    },
    edit(data) {
      this.festival.uuid = data.uuid;
      this.festival.name = data.name;
      this.festival.nameEn = data.nameEn;
      this.submitted = false;
      this.showModalEdit = true;
    },
    handleEditSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        if (
          (this.festivalList.includes(this.festival.name) &&
            this.festival.name !== this.festival.name) ||
          (this.festival.nameEn !== "" &&
            this.festivalListEn.includes(this.festival.nameEn) &&
            this.festival.nameEn !== this.festival.nameEn)
        ) {
          toast.error("this festival has already been used", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          return;
        }

        festivalSvc
          .update(this.festival.uuid, this.festival)
          .then((resp) => {
            if (resp.status === 200) {
              toast.success("Edited Successfully", {
                autoClose: localStorage.getItem("toastCountdown"),
              });
            } else {
              toast.error("Edited Failed", {
                autoClose: localStorage.getItem("toastCountdown"),
              });
            }
          })
          .catch((err) => {
            toast.error(err, {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          })
          .finally(() => {
            this.get();
            this.showModalEdit = false;
            this.submitted = false;
          });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-12">
                <!-- MODAL CREATE -->
                <div class="text-sm-end">
                  <button
                    type="button"
                    class="btn btn-success btn-rounded mb-2 me-2"
                    @click="create"
                  >
                    <i class="mdi mdi-plus me-1"></i> Add Festival
                  </button>
                  <b-modal
                    v-model="showModalCreate"
                    title="Add Festival"
                    title-class="text-black font-18"
                    body-class="p-3"
                    hide-footer
                    no-close-on-backdrop
                  >
                    <form @submit.prevent="handleSubmit">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="name"
                              >Name (TH)
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="name"
                              v-model="festival.name"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && v$.festival.name.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.festival.name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.festival.name.required.$message">{{
                                v$.festival.name.required.$message
                              }}</span>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="nameEn">Name (EN) <span class="is-required">*</span></label>
                            <input
                              id="nameEn"
                              v-model="festival.nameEn"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && v$.festival.nameEn.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.festival.nameEn.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.festival.nameEn.required.$message">{{
                                v$.festival.nameEn.required.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button
                          variant="light"
                          @click="showModalCreate = false"
                          >Close</b-button
                        >
                        <b-button type="submit" variant="success" class="ms-1"
                          >Create Festival</b-button
                        >
                      </div>
                    </form>
                  </b-modal>
                </div>
                <!-- MODAL CREATE -->

                <!-- MODAL EDIT -->
                <div class="text-sm-end">
                  <b-modal
                    v-model="showModalEdit"
                    :title="`Edit Festival : ${festival.name} / ${festival.nameEn}`"
                    title-class="text-black font-18"
                    body-class="p-3"
                    hide-footer
                    no-close-on-backdrop
                  >
                    <form @submit.prevent="handleEditSubmit">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="name"
                              >Name (TH)
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="uuid"
                              v-model="festival.uuid"
                              v-show="false"
                            />
                            <input
                              id="edit_name"
                              v-model="festival.name"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && v$.festival.name.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.festival.name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.festival.name.required.$message">{{
                                v$.festival.name.required.$message
                              }}</span>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="nameEn">Name (EN) </label>
                            <input
                              id="edit_nameEn"
                              v-model="festival.nameEn"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && v$.festival.nameEn.$error,
                              }"
                            />

                            <div
                              v-if="submitted && v$.festival.nameEn.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.festival.nameEn.required.$message">{{
                                v$.festival.nameEn.required.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalEdit = false"
                          >Close</b-button
                        >
                        <b-button type="submit" variant="warning" class="ms-1"
                          >Update Festival</b-button
                        >
                      </div>
                    </form>
                  </b-modal>
                </div>
                <!-- MODAL EDIT -->
              </div>
            </div>
            <div class="table-responsive">
              <vue-good-table
                :search-options="{
                  enabled: true,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  mode: 'records',
                }"
                :line-numbers="true"
                styleClass="tableOne vgt-table striped"
                :columns="columns"
                :rows="rows"
              >
                <template #table-row="props">
                  <span v-if="props.column.field == 'button'">
                    <b-button
                      size="sm"
                      variant="success"
                      @click="edit(props.formattedRow)"
                    >
                      <i
                        class="mdi mdi-pencil font-size-16 align-middle me-2"
                      ></i>
                      Edit
                    </b-button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
span.is-required {
  color: red;
}
</style>
